import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Info from './info';
import { getCommentCounts } from '@ifeng-fe/container_content/common/client/services/api';

class Recommend extends React.PureComponent {
    static propTypes = {
        data: PropTypes.array,
    };

    state = {
        counts: [],
    };

    async componentDidMount() {
        try {
            const { data } = this.props;
            const docUrl = data.map((item) => item.commentUrl);
            const counts = await getCommentCounts(docUrl);

            this.setState({
                counts,
            });
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { counts } = this.state;
        const { data } = this.props;

        return (
            <div className={styles.recommend}>
                <div className={styles.title}>
                    <h3>最新报道</h3>
                </div>
                <div className={styles.list_box}>
                    {data.map((item, index) => (
                        <Info key={item.id} data={item} count={counts[index]} />
                    ))}
                    <div className={styles.more}>
                        <a href='https://news.ifeng.com/loc/2024qglh' target='_blank'>
                            +更多内容
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Recommend);
